import { createRouter, createWebHistory } from 'vue-router'

// Importăm componentele tale
import MainLayout from '@/components/MainLayout.vue'
import HomePage from '../components/HomePage.vue'
import AboutUs from '../components/AboutUs.vue'
import ProductList from '../components/ProductList.vue'
import ProductDetail from '../components/ProductDetail.vue'
import ContactUs from '../components/ContactUs.vue'
import PrivacyPolicy from '../components/PrivacyPolicy.vue'
import TermsAndConditions from '../components/TermsAndConditions.vue'
import OfferRequest from '../components/OfferRequest.vue'

// Componentele de Admin
import AdminDashboard from '../components/AdminDashboard.vue'
import AdminLogin from '../components/AdminLogin.vue'

const routes = [
{
    path: '/',
    component: MainLayout,
    children: [
  // RUTE PUBLICE
  { path: '/', name: 'Home', component: HomePage },
  { path: 'despre', name: 'About', component: AboutUs },
  { path: 'produse', name: 'Products', component: ProductList },
  { path: 'produs/:id', name: 'ProductDetail', component: ProductDetail },
  { path: 'contact', name: 'Contact', component: ContactUs },
  { path: 'politica-confidentialitate', name: 'Privacy', component: PrivacyPolicy },
  { path: 'termeni-conditii', name: 'Terms', component: TermsAndConditions },
  { path: 'cerere-oferta', name: 'OfferRequest', component: OfferRequest },
    ] },
  // RUTA ADMIN (Unde avem cele două tab-uri: Produse/Categorii și Contacte)
  // GRUPA ADMIN (Fără Header/Footer public)
  {
    path: '/admin/login',
    name: 'Login',
    component: AdminLogin
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminDashboard,
    // Verificăm dacă e logat înainte să intre
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('carpatina_admin')) {
        next('/admin/login')
      } else {
        next()
      }
    }
}
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router